import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { resetOverlayCaches } from '../hooks/useOverlayConfig.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [overlayKey, setOverlayKey] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await api.me();
      setUser(data?.user ?? null);
      setOverlayKey(data?.overlayKey ?? null);
    } catch {
      setUser(null);
      setOverlayKey(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (username, password) => {
    resetOverlayCaches();
    await api.login(username, password);
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    await api.logout();
    setUser(null);
    setOverlayKey(null);
    resetOverlayCaches();
  }, []);

  return (
    <AuthContext.Provider value={{ user, overlayKey, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
